angular.module('zc.projects')

.directive 'zcCampaignInterestWidgetItemGraph', ($q, $translate, BaseCampaignInterestWidgetGraph, Chart) ->
  class Graph extends BaseCampaignInterestWidgetGraph
    link: (scope, element, attrs) ->
      scope.getStats = ->
        $q.all [
          scope.getInterestWidgetItemDistribution(true)
          scope.getInterestWidgetItemDistribution(false)
        ]

      scope.getChartConfig = ->
        scope.chartConfig = Chart.getChartConfig 'campaignInterestWidgetItembution',
          options:
            tooltip:
              valueSuffix: '%'
              valueDecimals: 2
            legend: false

      scope.addChartConfig = ([cart_button_click_stats, no_cart_button_click_stats]) ->
        no_cart_button_click_count = 0
        no_cart_button_click_count += stat.count for stat in no_cart_button_click_stats
        cart_button_click_count = 0
        cart_button_click_count += stat.count for stat in cart_button_click_stats
        scope.chartConfig.series = [
          name: $translate.instant('projectsCampaigns.directives.campaignInterestWidgetItemGraph.userWhoNotAddCartItems')
          data: ([i.from, i.count / no_cart_button_click_count * 100] for i in no_cart_button_click_stats)
        ,
          name: $translate.instant('projectsCampaigns.directives.campaignInterestWidgetItemGraph.userWhoAddCartItems')
          data: ([i.from, i.count / cart_button_click_count * 100] for i in cart_button_click_stats)
        ]

  return new Graph('hourly').createDirective()



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.campaigns/directives/campaign_interest_widget_item_graph.coffee